// ============================================================
// cf-modal.js � CF.modal (programmatic) + CF.confirm (dialog)
// Load hanya pada halaman yang membutuhkan modal / konfirmasi.
//
// Dependencies: site.js
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    // ????????????????????????????????????????????????????????
    // CF.modal � open / close / closeAll via element ID
    // ????????????????????????????????????????????????????????
    CF.modal = (function () {
        function open(id) {
            var el = document.getElementById(id);
            if (el) {
                el.style.display = '';
                document.body.style.overflow = 'hidden';

                // Auto-reset tabs inside this modal
                if (typeof CF.tabs !== 'undefined' && CF.tabs.reset) {
                    var tabBars = el.querySelectorAll('.cf-tabs[data-tab-group]');
                    tabBars.forEach(function (tb) {
                        var group = tb.getAttribute('data-tab-group');
                        if (group) CF.tabs.reset(group);
                    });
                }
            }
        }

        function close(id) {
            var el = document.getElementById(id);
            if (el) { el.style.display = 'none'; document.body.style.overflow = ''; }
        }

        function closeAll() {
            document.querySelectorAll('.cf-modal-backdrop').forEach(function (el) {
                el.style.display = 'none';
            });
            document.body.style.overflow = '';
        }

        document.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-modal-close]');
            if (btn) {
                var backdrop = btn.closest('.cf-modal-backdrop');
                if (backdrop) close(backdrop.id);
            }
        });

        return { open: open, close: close, closeAll: closeAll };
    })();

    // ????????????????????????????????????????????????????????
    // CF.confirm � Promise-based confirmation dialog
    // ????????????????????????????????????????????????????????
    CF.confirm = function (options) {
        if (typeof options === 'string') options = { message: options };

        var type        = options.type        || 'danger';
        var title       = options.title       || 'Confirm';
        var message     = options.message     || 'Are you sure?';
        var confirmText = options.confirmText || 'Yes';
        var cancelText  = options.cancelText  || 'Cancel';

        var ICONS = {
            danger:  'fa-solid fa-triangle-exclamation',
            warning: 'fa-solid fa-triangle-exclamation',
            info:    'fa-solid fa-circle-info'
        };

        return new Promise(function (resolve) {
            var backdrop = document.createElement('div');
            backdrop.className = 'cf-confirm-backdrop';
            backdrop.innerHTML =
                '<div class="cf-confirm">' +
                    '<div class="cf-confirm-icon cf-confirm-' + type + '">' +
                        '<i class="' + ICONS[type] + '"></i>' +
                    '</div>' +
                    '<h3 class="cf-confirm-title">' + title + '</h3>' +
                    '<p class="cf-confirm-message">' + message + '</p>' +
                    '<div class="cf-confirm-actions">' +
                        '<button class="cf-confirm-cancel">' + cancelText + '</button>' +
                        '<button class="cf-confirm-ok cf-confirm-btn-' + type + '">' + confirmText + '</button>' +
                    '</div>' +
                '</div>';

            function done(result) { backdrop.remove(); resolve(result); }

            backdrop.querySelector('.cf-confirm-cancel').onclick = function () { done(false); };
            backdrop.querySelector('.cf-confirm-ok').onclick     = function () { done(true); };
            backdrop.addEventListener('click', function (e) {
                if (e.target === backdrop) done(false);
            });

            document.body.appendChild(backdrop);
        });
    };

})();
